<template>
  <div class="toolWorkProgress">
    <el-container style="flex-direction: column;">
      <!-- <MachMonitor></MachMonitor> -->
      <NJNav></NJNav>
      <div class="charts-box">
        <div class="tab-box" style="text-align: center;">
          <div class="times" style="margin-bottom: 1vh;">
            <p>农机补贴机具作业进度图</p>
            <!-- <p>统计时间：截止到{{ getNowFormatDates() }}</p> -->
            <p>统计时间：{{ getFirstDayOfYear(new Date()) }}至{{ getNowFormatDates() }}</p>
            <!-- <p>统计时间：{{ getFirstDayOfYear(new Date()) }}至{{ getNowFormatDates() }}</p> -->
          </div>
          <span class="sub_title">*全国联网农机在本地区的作业进度</span>
        </div>
        <div class="tab-boxs">
          <div class="tool_work_items">
            <div v-for="(item, i) in njNumList1" :class="[{ 'active': activeName == item.catThreeName },'nj_items'+item.icon, 'item_Num']" :key="i" @click="tabItemClick(item)">
              <div></div>
              <div class="nj_num_content">
                <p class="nj_name">{{ item.catThreeName }}</p>
                <p class="nj_num">{{ item.area }}<span class="nj_danwei">{{item.workUnit}}亩次</span></p>
                <!-- <p class="nj_danwei">作业面积（亩次）</p> -->
              </div>
              <!-- <div>
                <p class="nj_num2">{{ item.workArea }}</p>
                <p class="nj_danwei">作业面积（亩次）</p>
              </div> -->
            </div>
          </div>
          <div class="select-block">
            <div id="ToolProChart"></div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import $ from "jquery";
import "echarts/map/js/china.js";
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
// import MachMonitor from "./MachMonitor.vue";
import NJNav from '../Index/view/NJNav'

export default {
  name: "ToolWorkProgress",
  components: {
    NJNav
    // MachMonitor
  },
  data() {
    return {
      progressTitleClass: '',
      numsClass: '',
      updateFrequency: 1000,
      dimension: 0,
      countryColors: {
        北京市: "#00008b",
        河北省: "#f00",
        吉林省: "#ffde00",
        黑龙江省: "#002a8f",
        上海市: "#003580",
        江苏省: "#ed2939",
        浙江省: "#000",
        安徽省: "#003897",
        福建省: "#f93",
        江西省: "#bc002d",
        山东省: "#024fa2",
        河南省: "#000",
        湖北省: "#00247d",
        广东省: "#ef2b2d",
        广西壮族自治区: "#dc143c",
        海南省: "#d52b1e",
        四川省: "#e30a17",
        云南省: "#00247d",
        陕西省: "#b22234",
        新疆维吾尔自治区: "#01C2FF"
      },
      // ROOT_PATH: 'https://cdn.jsdelivr.net/gh/apache/echarts-website@asf-site/examples',
      proCharts: "",
      itemList: [
        {
          id: "",
          name: "全部机具"
        },
        {
          id: 1,
          name: "拖拉机"
        },
        // {
        //   id: 5,
        //   name: "插秧机"
        // },
        {
          id: 2,
          name: "收割机"
        },
        {
          id: 0,
          name: '其它'
        }
      ],
      activeName: "全部智联机具",
      njNumList: [],
      cityName: this.$store.state.info.govLevel === 1 ? '本市' : '',
      nameArr: [],
      dataArr: [],
      // timer1: 0,
      timer1: [],
      years: [],
      njNumList1: []
    };
  },
  mounted() {
  	this.statisticMachine()
    this.init();
    this.queryDtIotNationalStatMapArea();
  },
  beforeDestroy() {
    const _this = this;
    for (let i = 0; i < this.years.length - 1; ++i) {
      clearTimeout(_this.timer1[i]);
    }
  },
  // destroyed() {
  // 	window.clearTimeout(this.timer1)
  // },
  methods: {
    init() {
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.proCharts.resize();
        });
      }, 30);
    },
    // 机具类型切换
    tabItemClick(item) {
      this.activeName = item.catThreeName;
      //   this.timer1 = 0;
      //   window.clearTimeout(this.timer1);
      for (let i = 0; i < this.years.length - 1; ++i) {
        clearTimeout(this.timer1[i]);
      }
      this.proCharts.clear();
      this.dataArr = [];
      this.years = [];
      this.queryDtIotNationalStatMapArea(item.catThreeCode);
    },
    // 请求数据
    queryDtIotNationalStatMapArea(typeId) {
      var parmse = {
        catThreeCode: typeId === "" ? "" : typeId
      };
      var url =
        Http.test + "/dtIotNationalStatMapArea/queryWorkSchedule";
      Api.doPost(url, parmse, false, res => {
        // this.nameArr = res.result.nameArr
        this.dataArr = res.result.dataArr;
        this.getCharts();
      });
    },
    statisticMachine() {
      // var url = Http.test + '/homePageStatisByJSController/getCountNjNumByLocal'
      var url = Http.test + '/screenBuyNj/njNumAndWorkArea'
      Api.doPost(url, null, false, res => {
        let data = JSON.parse(JSON.stringify(res.result));
					data.forEach((item, index) => {
						item.area = this.$common.unitFormat(Number(item.area))[0];
						item.workUnit = this.$common.unitFormat(Number(res.result[index].area))[1];
					})
					this.njNumList1 = data
        
      })
    },
    // 绘制图表
    getCharts() {
      this.$nextTick(() => {
        this.proCharts = this.$echarts.init(
          document.getElementById("ToolProChart")
        );
        // var flags = this.nameArr;
        var data = this.dataArr;
        // var years = [];
        this.years = []
        for (var i = 0; i < data.length; ++i) {
          if (
            this.years.length === 0 ||
            this.years[this.years.length - 1] !== data[i][2]
          ) {
            this.years.push(data[i][2]);
          }
        }
        var startIndex = 10;
        var startYear = this.years[startIndex];
        var option = {
          // backgroundColor: '#0B1640',
          tooltip: {
            trigger: "axis"
          },
          grid: {
            top: "2%",
            bottom: "5%",
            left: window.location.host === 'bdh.dtwl360.com' ? "7%" : window.location.host === 'xinjiang.dtwl360.com' || window.location.host === 'hunan.dtwl360.com' ? "9%" : '5%',
            right: "6%"
          },
          xAxis: {
            // boundaryGap: false,
            max: "dataMax",
            axisLabel: {
              color: "#C8C7DD",
              interval: 20
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
              // lineStyle: {
              //   color: '#dddddd'
              // },
              // width: 5
            },
            label: {
              formatter: function(n) {
                return Math.round(n);
              }
            }
          },
          // dataset: {
          //   source: data.slice(1).filter( (d) => {
          //     console.log(startYear)
          //     return d[4] === startYear;
          //   })
          // },
          yAxis: {
            type: "category",
            // boundaryGap: false,
            inverse: true,
            // max: 20,
            axisLine: {
              show: false
              // lineStyle: {
              //   color: '#dddddd'
              // },
              // width: 5
            },
            axisLabel: {
              color: "#C8C7DD",
              show: true,
              // textStyle: {
              //     fontSize: 14
              // },
              formatter: value => {
                // console.log(value)
                // return value + '{flag|' + getFlag(value) + '}';
                return value;
              },
              rich: {
                flag: {
                  // fontSize: 25,
                  padding: 5
                }
              }
            },
            animationDuration: 300,
            animationDurationUpdate: 300
          },
          series: [
            {
              realtimeSort: true,
              seriesLayoutBy: "column",
              type: "bar",
              barWidth: 15,
              // itemStyle: {
              //   color: (param) => {
              //     return this.countryColors[param.value[1]] || '#5470c6';
              //   }
              // },
              itemStyle: {
                color: "#0E5CF2"
                // color: function(params) {
                //   var colorList = [
                //     '#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',
                //     '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                //     '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
                //   ]
                //   return colorList[params.dataIndex]
                // }
              },
              encode: {
                x: this.dimension,
                y: 3
              },
              label: {
                color: "#fff",
                show: true,
                precision: 1,
                position: "right",
                formatter: param => {
                  return param.value[0] + "亩";
                }
                // valueAnimation: true,
                // fontFamily: 'monospace'
              }
            }
          ],
          // Disable init animation.
          animationDuration: 0,
          animationDurationUpdate: this.updateFrequency,
          animationEasing: "linear",
          animationEasingUpdate: "linear",
          graphic: {
            elements: [
              {
                type: "text",
                right: 160,
                bottom: 60,
                style: {
                  text: startYear,
                  font: "bolder 80px monospace",
                  fill: "rgba(100, 100, 100, 0.25)"
                },
                z: 100
              }
            ]
          }
        };
        this.proCharts.setOption(option);
        for (var i = 0; i < this.years.length - 1; ++i) {
          clearTimeout(this.timer1[i]);
          (i => {
            this.timer1[i] = window.setTimeout(() => {
              updateYear(this.years[i + 1], option);
            }, (i - 0) * this.updateFrequency);
          })(i);
        }
        var that = this;
        function updateYear(year, option) {
          var source = data.slice(1).filter(function(d) {
            return d[2] === year;
          });
          option.series[0].data = source;
          option.graphic.elements[0].style.text = year;
          that.proCharts.setOption(option);
        }
      });
    },
    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear(); // 年
      // this.yearValue = y
      var m = date.getMonth() + 1; // 月
      var d = date.getDate(); // 日
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 1 && d <= 9) {
        d = "0" + d;
      }
      // return y + '-' + m + '-' + d
      return y + "年" + m + "月" + d + "日";
    },
    // 获取本年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    },
    // 获取当前日期
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      // var year = date.getFullYear()
      var month = date.getMonth() + 1;
      this.thisMonth = month;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // var currentdate = year + seperator1 + month + seperator1 + strDate
      var currentdate = month + "月" + strDate + "日";
      return currentdate;
    }
  }
};
</script>
<style scoped>
  /*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width:3px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
  border-radius:10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius:10px;
  background:#0A63C6;
  -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
}
.toolWorkProgress {
  width: 100%;
  height: 72vh;
}
.charts-box {
  width: 98%;
  height: 83vh;
  background-image: url("/static/img/zuoyejindu-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-left: 1%;
  margin-top: 1vh;
}
.tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
	
.tab-boxs {
		width: 98%;
		margin-left: 1%;
		display: flex;
		/* background: #0B1640; */
		/* justify-content: space-between; */
	}
/* @media screen and (max-width: 1540px) {
  .charts-box {
    height: 88vh;
  }
} */

/* .select-block-pro {
  width: 100%;
  height: 73vh;
} */

.select-block{
    width: 90%;
    height: 75vh;
  }

#ToolProChart {
  width: 100%;
  height: 74vh;
  margin-left: 1%;
}

.charts-box-top {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.tablist_item {
  /*width: 30%;
  display: flex;*/
  margin-left: 1%;
  padding-top: 5px;
  width: 100vw;
}

.sub_title{
		font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFF600;

	}
</style>



// WEBPACK FOOTER //
// src/components/TableList/ToolWorkProgress.vue